(() => {
  const blocks = () => [...document.querySelectorAll('[data-invoice]')];
  const update = (block, checked) => {
    block.querySelector('[data-invoice-toggle]').checked = checked;
    block.querySelector('[data-invoice-value]').value = checked ? 'Tak' : 'Nie';
    block.querySelector('[data-invoice-fields]').hidden = !checked;
    block.querySelectorAll('[data-invoice-field]').forEach(field => {
      field.required = checked && field.dataset.invoiceField !== 'nip';
      if (!checked) field.value = '';
    });
  };
  blocks().forEach(block => update(block, block.querySelector('[data-invoice-toggle]').checked));
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-invoice-toggle]')) return;
    blocks().forEach(block => update(block, event.target.checked));
  });
  document.addEventListener('input', event => {
    const key = event.target.dataset.invoiceField;
    if (!key) return;
    blocks().forEach(block => {
      const field = block.querySelector(`[data-invoice-field="${key}"]`);
      if (field !== event.target) field.value = event.target.value;
    });
  });
  // The theme uses novalidate. Check only invoice fields before its submit handler.
  document.addEventListener('submit', event => {
    const block = event.target.querySelector('[data-invoice]');
    if (!block || !block.querySelector('[data-invoice-toggle]').checked) return;
    const invalid = [...block.querySelectorAll('[data-invoice-field]')].find(field => {
      if (field.required && !field.value.trim()) {
        field.setCustomValidity('Uzupełnij to pole.');
      } else field.setCustomValidity('');
      return !field.checkValidity();
    });
    if (invalid) {
      event.preventDefault();
      event.stopImmediatePropagation();
      invalid.reportValidity();
    }
  }, true);
  document.addEventListener('input', event => {
    if (event.target.matches('[data-invoice-field]')) event.target.setCustomValidity('');
  });
})();
